export const iconFontAwesomeArrowsCircleArrowLeft = (
	<i className="fa-solid fa-circle-arrow-left"></i>
);
